import isObject from 'lodash-es/isObject';
import { joinPath } from '../utils/path';
export function fromJsonData(rootData, opts = {}) {
    function cvtNode(data, ctx) {
        var _a, _b;
        const ans = { type: 'any' };
        if (typeof opts.convertor === 'function') {
            const res = opts.convertor(data, ctx);
            if (isObject(res))
                return res;
        }
        switch (typeof data) {
            case 'number':
                ans.type = 'number';
                break;
            case 'boolean':
                ans.type = 'boolean';
                break;
            case 'string':
                ans.type = 'string';
                break;
            case 'object':
                if (Array.isArray(data)) {
                    const arrayItem = (_b = (_a = data[0]) !== null && _a !== void 0 ? _a : data[1]) !== null && _b !== void 0 ? _b : data[2];
                    // eslint-disable-next-line eqeqeq
                    if (arrayItem == null && opts.emptyArray === 'error') {
                        throw new Error(`遇到了空数组，无法转换：${ctx.pathPrefix}`);
                    }
                    ans.type = 'array';
                    ans.items = cvtNode(arrayItem, Object.assign(Object.assign({}, ctx), { depth: ctx.depth + 1, pathPrefix: joinPath([ctx.pathPrefix, 0]) }));
                }
                else if (!!data) {
                    // 避免 null
                    ans.type = 'object';
                    ans.fields = Object.keys(data)
                        .map((id) => {
                        const val = data[id];
                        if ((typeof val === 'undefined' || typeof val === 'function') && !opts.keepInvalidFields) {
                            return null;
                        }
                        const subAns = Object.assign({ id }, cvtNode(val, Object.assign(Object.assign({}, ctx), { depth: ctx.depth + 1, pathPrefix: joinPath([ctx.pathPrefix, id]) })));
                        if (opts.allRequired)
                            subAns.required = true;
                        return subAns;
                    })
                        .filter((x) => !!x);
                }
                break;
        }
        return ans;
    }
    return cvtNode(rootData, {
        pathPrefix: '',
        depth: 0,
    });
}
